import {InjectionToken} from '@angular/core';
import type {AdPositionMap} from '@candyland/generic/shared/model-nmo';

export const DFP_AD_POSITIONS = new InjectionToken<AdPositionMap>('DFP Ad Positions');
